// @flow
import React from 'react';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from '@finect/front-core/ScrollToTop';
import { AppWithRouter } from './App';
import AppRouter from './AppRouter';
import { OmniNavListener } from './components';

type Props = {
  initializedStore: Object
};

const BrowserApp = ({ initializedStore }: Props) => (
  <HelmetProvider>
    <Provider store={initializedStore}>
      <AppWithRouter>
        <ScrollToTop />
        <OmniNavListener />
        <AppRouter />
      </AppWithRouter>
    </Provider>
  </HelmetProvider>
);

export default BrowserApp;
